<template>
	<div class="index-box">
		<div class="all-center-box">
			<div class="w-1500">
				<div class="home-box5 w-100">
					<div class="all-title-box w-100 between-center">
						<div class="pull-left">搜索结果</div>
					</div>
					<template v-if="recommendArry.length !== 0">
						<div class="box-info w-100">
							<ul>
								<li v-for="(item,index) in recommendArry" :key="index" @click="clickDetails(item)">
									<a>
										<i><img :src="item.coverUrl" :alt="item.name"></i>
										<p>{{item.name}}</p>
									</a>
								</li>
							</ul>
						</div>
						<el-pagination class="w-100" background layout="prev, pager, next" :total="totalPage" :page-size="pageSize"
							@current-change="currentChange" @prev-click="prevClick" @next-click="nextClick">
						</el-pagination>
					</template>
					<template v-else>
						<div class="data-error" style="padding:100px 0 50px;text-align: center;">
							<img width="200" src="/static/img/no_data5.png" alt="图片">
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { searchGoodsList, getGoodsCategorys } from '@/common/http.js';
	export default {
		data() {
			return {
				recommendArry: [],
				totalPage: 0,
				pageSize: 28,
				pageIndex: 1
			}
		},
		mounted() {
			this.getList();
		},
    watch:{
      '$store.state.searchValue':function(){
        this.getList();
      }
    },
		methods: {
			getList() {
        const searchValue = this.$store.state.searchValue;
				searchGoodsList({
					pageIndex: this.pageIndex,
					pageSize: this.pageSize,
					search: searchValue,
					state: 10
				}).then(res => {
					if (res.result) {
						this.recommendArry = res.data.rows;
						this.totalPage = res.data.total;
					}
				})
			},
			clickDetails(item) {
				let that = this;

				getGoodsCategorys({ goodsid: item.id }).then(res => {
					if (res.result) {
						let params = {
							// obj: encodeURIComponent(JSON.stringify(item))
							productId: res.data.category.id,
							uid: item.uid,
							childrenName: res.data.category.name
						}

						this.$router.push({
							name: 'productTypeScreen',
							path: '/productTypeScreen',
							query: params
						})
					}
				})

				// let params = {
				// 	// obj: encodeURIComponent(JSON.stringify(item))
        //   obj: item.uid
				// }
				// const routerJump = this.$router.resolve({
				// 	name: 'productDetails',
				// 	path: '/productDetails',
				// 	query: params
				// })

				// let params = {
				// 	// obj: encodeURIComponent(JSON.stringify(item))
        //   productId: item.id,
				// 	uid: item.uid,
				// 	childrenName: item.name
				// }

				// this.$router.push({
				// 	name: 'productTypeScreen',
				// 	path: '/productTypeScreen',
				// 	query: params
				// })

				// const routerJump = this.$router.resolve({
				// 	name: 'productTypeScreen',
				// 	path: '/productTypeScreen',
				// 	query: params
				// })
				// window.open(routerJump.href, '_blank')
			},
			currentChange(evt) {
				this.pageIndex = evt;
				this.getList();
			},
			prevClick() {
				this.pageIndex -= 1;
				this.getList();
			},
			nextClick() {
				this.pageIndex += 1;
				this.getList();
			}
		}
	}
</script>

<style scoped="scoped">
	.box-info {
		margin-bottom: 20px;
	}
	.el-pagination{
		text-align: center;
		margin: 20px 0 40px;
		padding: 0;
	}
	::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
		background-color: #004194;
	}
</style>



// WEBPACK FOOTER //
// src/pages/search/search.vue